import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=3de26626&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=3de26626&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de26626",
  null
  
)

export default component.exports